import React, { Component } from 'react';

import socialHttp from '../../../utils/socialHttp';

import Image from 'Demora/image';

import ProfileNextToName from 'resources/assets/react-app/uiHooks/react-social/profileNextToName';

import { Link } from 'react-router-dom';

import alert from 'Demora/modals/alert';

class UserSearch extends Component {
	constructor() {
		super();

		this.state = {
			data: {},
			loaded: false,
			search: '',
			users: [],
		};
	}

	handleChange = (event) => {
		this.setState({ search: event.target.value });
	};

	handleSubmit = (event) => {
		event.preventDefault();

		let state = this.state;

		let s = state.search;

		if (s.length < 4) {
			alert(
				'search_too_short',
				'Error',
				'You need to type at least 4 letters.'
			);

			return;
		}

		const params = {
			search: s,
		};

		if (this.props.obj) {
			params.obj = this.props.obj;
		}

		socialHttp('post', '/data/searchUsers', params)
			.then((data) => {
				let users = [[], [], []];

				Object.keys(data.users).map((uid) => {
					let user = data.users[uid];

					if (!user) {
						return;
					}

					if (
						(user.first_name == data.first_name &&
							user.last_name == data.last_name) ||
						(user.first_name == data.first_name && !data.last_name) ||
						(user.last_name == data.last_name && !data.first_name)
					) {
						users[0].push(user);
					} else if (
						user.first_name == data.first_name ||
						user.last_name == data.last_name
					) {
						users[1].push(user);
					} else {
						users[2].push(user);
					}
				});

				this.setState({
					data: data,
					loaded: true,
					users: users,
				});
			})
			.catch((e) => {
				throw e;
			});
	};

	country(u) {
		if (!u) {
			return null;
		}

		let cis = u.countrySelected;

		let cip = u.countryFromIp;

		if (!cip) {
			return null;
		}

		if (!cis) {
			cis = cip;
		}

		return (
			<div className='small'>
				<div>
					<img
						style={{ width: '25px' }}
						src={'/assets/countries/' + cis.code.toLowerCase() + '.gif'}
					/>{' '}
					{cis.name}
					{cis.code != cip.code && (
						<span>
							&nbsp;(location{' '}
							<img
								style={{ width: '25px' }}
								src={'/assets/countries/' + cip.code.toLowerCase() + '.gif'}
							/>{' '}
							{cip.name})
						</span>
					)}
				</div>
			</div>
		);
	}

	drawRow(user) {
		if (this.props.drawRow) {
			return this.props.drawRow(user);
		}

		let obj = user.id + '-u';

		return (
			<div style={{ maxWidth: '400px' }} className='mx-auto' key={user.id}>
				<Link to={'/profile/' + obj}>
					<div className='col-12 mb-1'>
						<div className='row'>
							<div className='col' style={{ maxWidth: '70px' }}>
								<img
									src={!user ? '' : Image(user.image, 50)}
									className='rounded'
									style={{ padding: '2px', border: 'solid 1px #bbb' }}
								/>
							</div>
							<div className='col'>
								<div>
									<span className='user-name'>
										{user.first_name + ' ' + user.last_name}
									</span>

									<ProfileNextToName obj={obj} />
								</div>
								<div>{this.country(user)}</div>
							</div>
						</div>

						<hr />
					</div>
				</Link>
			</div>
		);
	}

	render() {
		const state = this.state;

		return (
			<div className='row mx-auto'>
				<div className='col-12'>
					<h3 className='mx-auto' style={{ maxWidth: '400px' }}>
						Search
					</h3>
				</div>

				<div className='col-12 text-center'>
					<form
						onSubmit={this.handleSubmit}
						className='mx-auto'
						style={{ maxWidth: '400px' }}
					>
						<div className='input-group mb-3'>
							<input
								type='text'
								value={state.search}
								onChange={this.handleChange}
								className='form-control'
							/>
							<div className='input-group-append'>
								<input
									type='submit'
									value='Search'
									className='btn btn-primary'
								/>
							</div>
						</div>
					</form>
				</div>

				{state.loaded && (
					<div className='col-12'>
						{state.users.map((u1, k) => {
							return (
								<div key={k}>
									<h3
										className='mt-5 mb-5 mx-auto'
										style={{ maxWidth: '400px' }}
									>
										{['Exact matches', 'Others', ''][k]}
									</h3>

									{k == 0 && u1.length == 0 && (
										<div className='text-center pt-3 pb-3'>None</div>
									)}
									{k == 1 &&
										state.users[1].length == 0 &&
										state.users[2].length == 0 && (
											<div className='text-center pt-3 pb-3'>None</div>
										)}

									{u1.map((u2) => {
										return this.drawRow(u2);
									})}
								</div>
							);
						})}
					</div>
				)}
			</div>
		);
	}
}

export default UserSearch;
